import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import { getLoyaltyHistory } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";
import {
  LoyaltyHistoryColumns,
  mapLoyaltyHistoryQuery,
  loyaltyHistorySearchSchema,
} from "./LoyaltyHistoryView.default";

export interface LoyaltyHistoryViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
  readonly onAction?: (key: string, record: any) => void;
}

function LoyaltyHistoryView(props: LoyaltyHistoryViewProps) {
  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={LoyaltyHistoryColumns}
      schema={loyaltyHistorySearchSchema}
      mapQuery={mapLoyaltyHistoryQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getLoyaltyHistory, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "view",
          label: "View",
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default LoyaltyHistoryView;
